export default __webpack_public_path__ + "static/icon-26-1-4125c4f605d108d5561013038fd1de9d.png";